<script setup>
import { ref, watch } from 'vue';
import { useCcm19Global } from '../../useCcm19Global';
import CookieReset from '../CookieReset.vue';

const videoPlaying = ref(false);
const VIDEO_ID = '0y8ulPmljeY';
const thumbnailUrl = ref('');
const thumbnailLoaded = ref(false);

const { onReady, youtube } = useCcm19Global();
onReady(() => {});

const loadThumbnail = async () => {
    if (thumbnailLoaded.value) return;

    const maxres = `https://img.youtube.com/vi/${VIDEO_ID}/maxresdefault.jpg`;
    const hq = `https://img.youtube.com/vi/${VIDEO_ID}/hqdefault.jpg`;
    try {
        const res = await fetch(maxres, { method: 'HEAD' });
        thumbnailUrl.value = res.ok ? maxres : hq;
    } catch {
        thumbnailUrl.value = hq;
    } finally {
        thumbnailLoaded.value = true;
    }
};
const playVideo = () => {
    videoPlaying.value = true;
};

watch(
    youtube,
    (val) => {
        if (val) loadThumbnail();
    },
    { immediate: true }
);
</script>

<template>
    <section class="relative video-section">
        <div class="mx-auto max-w-5xl w-full">
            <div v-if="youtube">
                <div class="relative w-full aspect-video rounded-lg overflow-hidden shadow-lg">
                    <button v-if="!videoPlaying" class="group absolute inset-0 w-full h-full cursor-pointer" aria-label="Play Video" @click="playVideo">
                        <img
                            :src="thumbnailUrl"
                            alt="Video Thumbnail"
                            class="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                            width="1280"
                            height="720"
                            loading="lazy"
                        />
                        <div class="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/40 transition">
                            <div class="bg-white/80 rounded-full w-16 h-16 flex items-center justify-center">
                                <i class="fi fi-ss-play text-black text-3xl mt-0.5"></i>
                            </div>
                        </div>
                    </button>
                    <iframe
                        v-else
                        class="absolute inset-0 w-full h-full"
                        :src="`https://www.youtube-nocookie.com/embed/${VIDEO_ID}?autoplay=1`"
                        title="YouTube video"
                        allow="autoplay; encrypted-media"
                        allowfullscreen
                    ></iframe>
                </div>
            </div>
            <div v-else>
                <div class="relative w-full aspect-video rounded-lg overflow-hidden shadow-lg bg-gray-100 flex items-center justify-center">
                    <div class="absolute inset-0 bg-gradient-to-br from-gray-200 via-gray-100 to-gray-50"></div>
                    <div class="relative z-10 flex flex-col items-center gap-3 px-6 text-center">
                        <div class="w-16 h-16 rounded-full bg-white shadow flex items-center justify-center">
                            <i class="fi fi-rr-play text-gray-400 text-3xl"></i>
                        </div>
                        <p class="text-sm text-gray-600 font-medium">{{ $t('scampage.blockedVideo') }}</p>

                        <CookieReset class="mt-2" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
